module.exports = __webpack_public_path__ + "static/img/banner03.846cb13c.webp";